import * as RadixTooltip from '@radix-ui/react-tooltip'
import type { ReactNode } from 'react'

/** One provider at the app root; delay tuned for a dense grid, not a marketing site. */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <RadixTooltip.Provider delayDuration={260} skipDelayDuration={120}>
      {children}
    </RadixTooltip.Provider>
  )
}

/**
 * Explanatory tooltip.
 *
 * Reserved for rules that are not self-evident from the number — how an outlier
 * is decided, what a threshold mark means. Never used to hide a label that
 * should have been on screen.
 */
export function Tooltip({
  content,
  children,
  side = 'top',
}: {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
}) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={5}
          collisionPadding={8}
          className="z-50 max-w-72 bg-raised px-2 py-1.5 text-sm leading-snug text-fg-secondary shadow-overlay"
        >
          {content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  )
}
